import { cx } from "../lib/cx"

type CardProps = {
  children: React.ReactNode
  className?: string
  onClick?: () => void
}

const Card = ({ children, className, onClick }: CardProps) => (
  <div
    className={cx(
      "rounded-[24px] border border-line bg-white/90 p-5 shadow-soft",
      onClick && "cursor-pointer",
      className,
    )}
    onClick={onClick}
  >
    {children}
  </div>
)

export default Card
